import { render } from "./UserGuidelineBody.vue?vue&type=template&id=0f58489f&scoped=true"
const script = {}

import "./UserGuidelineBody.vue?vue&type=style&index=0&id=0f58489f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f58489f"]])

export default __exports__